import api from "../../../utils/api";

export const dealerSearchMap = ({ maps, mapStyles, mapTarget }) => {
    return new maps.Map(mapTarget, {
        zoom: 1,
        center: { lat: 0, lng: 0 },
        mapTypeControl: false,
        styles: mapStyles,
    });
};

export const baiduDealerSearchMap = ({ maps, mapTarget }) => {
    return new maps.Map(mapTarget, {
        zoom: 1,
        center: new maps.Point(btoa("0"), btoa("0")),
        mapTypeControl: false,
    });
};

export function submitForm(e: Event) {
    e.preventDefault();
    this.sliderReady = false;
    this.noResults = false;
    if (this.config === null) return;
    const fetchUrl = this.config?.fetchUrl;
    try {
        const postcodeInput =
            this.formElement.querySelector("input[type='text']");
        const postcode = postcodeInput.value.trim();
        const allDealersCheckbox = this.formElement.querySelector(
            "input[type='checkbox']"
        ) as HTMLInputElement;
        const allDealers = allDealersCheckbox.checked ? "1" : "0";
        api(
            fetchUrl +
                "?" +
                new URLSearchParams({
                    plz: postcode || this.postcode,
                    showAll: allDealers,
                })
        )
            .then((response: any) => {
                this.postcode = postcode;
                if (response.location.length === 0) {
                    this.noResults = true;
                }
                this.apiResponse = response;
            })
            .catch(() => {
                this.error = true;
            });
    } catch {
        this.error = true;
    }
}

export function changePostcode() {
    const postcodeElement = document.querySelector(this.noResultsCodeSelector);
    postcodeElement.innerHTML = this.postcode;
}

export function toggleNoResultsMsg() {
    const postcodeElement = document.querySelector(this.noResultsCodeSelector);
    const parent = postcodeElement.parentElement;
    if (this.noResults === true) parent.style.display = "block";
    else parent.style.display = "none";
}

export function clearMarkers() {
    if (this.mapProvider === "baidu") {
        this.map.clearOverlays();
    } else {
        this.markers.forEach((marker) => {
            marker.setMap(null);
        });
    }
    this.markers = [];
}

export function clearCountries() {
    this.countries.forEach((country) => {
        country.setMap(null);
    });
    this.countries = [];
}

interface IconInfo {
    url: string;
    sizeX: number;
    sizeY: number;
    anchorX: number;
    anchorY: number;
}

function getIcon(mapProvider: string, maps: any, iconInfo: IconInfo) {
    const { url, sizeX, sizeY, anchorX, anchorY } = iconInfo;
    if (mapProvider === "google") {
        return {
            url,
            scaledSize: new maps.Size(sizeX, sizeY),
            origin: new maps.Point(0, 0),
            anchor: new maps.Point(anchorX, anchorY),
        };
    } else if (mapProvider === "baidu") {
        return new maps.Icon(url, new maps.Size(sizeX, sizeY), {
            anchor: new maps.Size(anchorX, anchorY),
            origin: new maps.Size(0, 0),
        });
    }
}

interface IconConfig {
    logo_icon: string;
    gray_icon: string;
    blue_icon: string;
    green_icon: string;
    globe_icon: string;
    globe_icon_hover: string;
}

export function getIcons(config: IconConfig, maps: any, mapProvider: string) {
    const icon = (iconInfo: IconInfo) => getIcon(mapProvider, maps, iconInfo);
    return {
        logo: icon({
            url: config?.logo_icon,
            sizeX: 30,
            sizeY: 30,
            anchorX: 15,
            anchorY: 15,
        }),
        gray: icon({
            url: config?.gray_icon,
            sizeX: 36,
            sizeY: 40,
            anchorX: 16.2,
            anchorY: 36,
        }),
        blue: icon({
            url: config?.blue_icon,
            sizeX: 36,
            sizeY: 40,
            anchorX: 17,
            anchorY: 36,
        }),
        green: icon({
            url: config?.green_icon,
            sizeX: 56,
            sizeY: 60,
            anchorX: 25.2,
            anchorY: 54,
        }),
        gray_hover: icon({
            url: config?.gray_icon,
            sizeX: 56,
            sizeY: 60,
            anchorX: 25.2,
            anchorY: 54,
        }),
        blue_hover: icon({
            url: config?.blue_icon,
            sizeX: 56,
            sizeY: 60,
            anchorX: 25.2,
            anchorY: 54,
        }),
        green_hover: icon({
            url: config?.green_icon,
            sizeX: 56,
            sizeY: 60,
            anchorX: 25.2,
            anchorY: 54,
        }),
        jump_to_other_country: icon({
            url: config?.globe_icon,
            sizeX: 56,
            sizeY: 56,
            anchorX: 28,
            anchorY: 28,
        }),
        jump_to_other_country_hover: icon({
            url: config?.globe_icon_hover,
            sizeX: 56,
            sizeY: 56,
            anchorX: 15,
            anchorY: 15,
        }),
    };
}

export function setMarkers({ withCountries, mapProvider }) {
    const icons = getIcons(this.config, this.maps, mapProvider);
    this.clearMarkers();
    this.clearCountries();
    if (this.apiResponse.location.length === 0) return;
    centerMapInBounds({
        map: this.map,
        locations: this.apiResponse.location,
        mapProvider,
        maps: this.maps,
    });
    this.apiResponse.location.forEach((location, index) => {
        this.markers[index] = createMarker({
            map: this.map,
            location,
            mapProvider,
            maps: this.maps,
            icon: icons[location.type],
        });

        addEventListenerForMarker({
            marker: this.markers[index],
            mapProvider,
            eventType: "mouseover",
            callback: () => {
                highlightMarker(
                    index,
                    this.map,
                    this.locationSlider,
                    this.markers,
                    icons,
                    location.type,
                    false
                );
            },
        });
        addEventListenerForMarker({
            marker: this.markers[index],
            mapProvider,
            eventType: "mouseout",
            callback: () => {
                deHighlightMarker(
                    index,
                    this.markers,
                    this.locationSlider,
                    location.type,
                    icons
                );
            },
        });

        if (location.link) {
            addEventListenerForMarker({
                marker: this.markers[index],
                mapProvider,
                eventType: "click",
                callback: () => {
                    window.location.href = location.link;
                },
            });
        }
        setTimeout(() => {
            const slides =
                this.locationSlider.querySelectorAll("ux-slider-slide");
            slides[index].addEventListener("mouseover", () => {
                highlightMarker(
                    index,
                    this.map,
                    this.locationSlider,
                    this.markers,
                    icons,
                    location.type,
                    true
                );
            });
            slides[index].addEventListener("mouseout", () => {
                deHighlightMarker(
                    index,
                    this.markers,
                    this.locationSlider,
                    location.type,
                    icons
                );
            });
        }, 1000);
    });

    if (withCountries === true) {
        this.apiResponse.countries.forEach((country, index) => {
            this.countries[index] = createMarker({
                map: this.map,
                location: country,
                mapProvider,
                maps: this.maps,
                icon: icons["jump_to_other_country"],
            });

            const infoWindow = createInfoWindow({
                mapProvider,
                maps: this.maps,
                content: country.name,
            });

            addEventListenerForMarker({
                marker: this.countries[index],
                mapProvider,
                eventType: "mouseover",
                callback: () => {
                    openInfoWindow({
                        infoWindow,
                        map: this.map,
                        marker: this.countries[index],
                        mapProvider,
                    });
                },
            });

            addEventListenerForMarker({
                marker: this.countries[index],
                mapProvider,
                eventType: "mouseout",
                callback: () => {
                    closeInfoWindow({
                        infoWindow,
                        map: this.map,
                        marker: this.countries[index],
                        mapProvider,
                    });
                },
            });

            addEventListenerForMarker({
                marker: this.countries[index],
                mapProvider,
                eventType: "click",
                callback: () => {
                    window.location.href = country.link;
                },
            });
        });
    }
}

function centerMapInBounds({ map, locations, mapProvider, maps }) {
    if (mapProvider === "google") {
        const maxZoomLevel = 14;
        const bounds = new maps.LatLngBounds();
        locations.forEach((location) => {
            bounds.extend(location.lat_lng);
        });
        map.fitBounds(bounds);
        if (map.getZoom() > maxZoomLevel) {
            map.setZoom(maxZoomLevel);
        }
    } else if (mapProvider === "baidu") {
        const points = locations.map(
            (location) =>
                new maps.Point(
                    btoa(location.lat_lng.lng),
                    btoa(location.lat_lng.lat)
                )
        );
        map.setViewport(points);
    }
}

function createMarker({ map, location, icon, maps, mapProvider }) {
    if (mapProvider === "google") {
        return new maps.Marker({
            position: location.lat_lng,
            map,
            icon,
            url: location.link,
            zIndex: location.type === "green" ? 10 : 1,
        });
    } else if (mapProvider === "baidu") {
        const marker = new maps.Marker(
            new maps.Point(
                btoa(location.lat_lng.lng),
                btoa(location.lat_lng.lat)
            ),
            {
                icon,
            }
        );
        map.addOverlay(marker);
        return marker;
    }
}

function addEventListenerForMarker({
    marker,
    mapProvider,
    eventType,
    callback,
}) {
    if (mapProvider === "google") {
        marker.addListener(eventType, callback);
    } else if (mapProvider === "baidu") {
        marker.addEventListener(eventType, callback);
    }
}

function createInfoWindow({ mapProvider, maps, content }) {
    if (mapProvider === "google") {
        return new maps.InfoWindow({
            content,
        });
    } else if (mapProvider === "baidu") {
        return new maps.InfoWindow(content, {
            width: 100,
            height: 50,
        });
    }
}

function openInfoWindow({ infoWindow, map, marker, mapProvider }) {
    if (mapProvider === "google") {
        infoWindow.open(map, marker);
    } else if (mapProvider === "baidu") {
        map.openInfoWindow(infoWindow, marker.point);
    }
}

function closeInfoWindow({ infoWindow, map, marker, mapProvider }) {
    if (mapProvider === "google") {
        infoWindow.close(map, marker);
    } else if (mapProvider === "baidu") {
        map.closeInfoWindow(infoWindow);
    }
}

const highlightMarker = (
    index: number,
    map: any,
    slider: any,
    markers: any,
    icons: any,
    locationType: string,
    centerMap: boolean
) => {
    const newIcon = locationType + "_hover";
    const marker = markers[index];

    if (marker) {
        marker.setIcon(icons[newIcon]);
        marker.setZIndex(15);
    }

    if (centerMap) {
        if (map && marker) map.panTo(marker.position);
        highlightElement(slider, index);
    } else {
        slider.slideTo(index, 400);
        highlightElement(slider, index);
    }
};

export const deHighlightMarker = (
    index,
    markers,
    slider,
    locationtype,
    icons
) => {
    markers[index].setIcon(icons[locationtype]);
    if (locationtype === "green") {
        markers[index].setZIndex(10);
    } else {
        markers[index].setZIndex(1);
    }
    const slides = slider.querySelectorAll("ux-slider-slide");
    slides.forEach((slide) => {
        slide.classList.remove("slide-disabled");
    });
};

const highlightElement = (slider, activeIndex) => {
    const slides = slider.querySelectorAll("ux-slider-slide");
    slides.forEach((slide, index) => {
        if (
            index !== activeIndex &&
            !slide.classList.contains("slide-disabled")
        ) {
            slide.classList.add("slide-disabled");
        } else if (
            index === activeIndex &&
            slide.classList.contains("slide-disabled")
        ) {
            slide.classList.remove("slide-disabled");
        }
    });
};
